/* eslint-disable import/prefer-default-export */

export const getRedirectHref = (path: string, locale: string = "id") => {
  if (path === "/" || path.includes("register") || path.includes("login")) {
    return `/login-page`;
  }
  return `/login-page?redirect=${path}`;
};
